/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var homeHeader = {
  settings: {
    el: $('#home'),
    nav: $('nav')
  },
  init: function init() {
    s = this.settings;
    $(window).scroll(function () {
      if ($(window).scrollTop() >= s.el.offset().top - s.nav.height()) {
        s.nav.removeClass('hidden');
      } else {
        s.nav.addClass('hidden');
      }
    });
  }
};
var backToTop = {
  settings: {
    el: $('#back-to-top')
  },
  init: function init() {
    se = this.settings;
    // Show only when scrolled
    $(window).scroll(function () {
      if ($(window).scrollTop() > 700) {
        se.el.removeClass('invisible');
      } else {
        se.el.addClass('invisible');
      }
    });
    // On click go back to top
    se.el.on('click', function () {
      offset = $('.filter').offset().top - $('nav.menu').height();
      $('html, body').animate({ scrollTop: offset }, 1000);
    });
  }
};

$(function () {
  // Sticky Nav only for Homepage, also BackToTop on Homepage
  if ($('html').hasClass('home')) {
    homeHeader.init();backToTop.init();
  }
  // Sticky Nav only on Posts pages
  if ($('html').hasClass('posts')) {
    backToTop.init();
  }
  // InfiniteScroll Plugin
  $('.all-posts').infiniteScroll({
    path: '.pagination__next',
    append: 'article',
    history: false
  });
});

$(window).load(function () {
  // Fully load on Homepage
  $('body').addClass('loaded');
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/bundle.js